export default __webpack_public_path__ + "static/media/blog-02.ae7a3e0c.jpg";